Vue.component('home-date-picker', {
    template: `
        <div ref="date_picker" class="dropdown-select date-picker">
            <i class="far fa-calendar f1 align-middle mr-2"></i> <span>{{ date_text }}</span>
        </div>
    `,

    props: [
        'fromDate', 'toDate',   // YYYY-MM-DD formatted
        'dateRange',
        'emit'
    ],

    computed: {

        date_text() {
            return this.getDatePickerLabel( this.fromDate, this.toDate, this.dateRange )
        }

    },

    mounted() {
        // console.log( 'home-date-picker.js mounted: ' )
        // console.log( this.fromDate )
        // console.log( this.toDate )

        Vue.directive('tooltip', function(el, binding){
            
            $(el).tooltip({
                title: binding.value,
                placement: binding.arg,
                trigger: 'hover',
                html: true
            })

        })
        
        moment.locale()
        
        let element = this.$refs.date_picker

        $(element).daterangepicker({
            ranges: this.getDefaultDateRanges(),
            autoApply: true,
            startDate: moment(this.fromDate),
            endDate: moment(this.toDate),
            alwaysShowCalendars: true,
            opens: 'center',
            showDropdowns: true,
            minDate: moment('2000-01-01'),
            maxDate: moment().endOf('year')
        }, this.updateDates)

        this.fromDate = this.fromDate
        this.toDate = this.toDate
        this.dateRange = this.dateRange

    },

    methods: {
        updateDates(fromDate, toDate, type) {
            this.dateLabel = type
            this.$emit('dates-changed', fromDate.format("YYYY-MM-DD"), toDate.format("YYYY-MM-DD"), type)
            if (this.emit) {
                this.$eventHub.$emit('update-home-dates', fromDate.format("YYYY-MM-DD"), toDate.format("YYYY-MM-DD"), type)
            this.$eventHub.$emit('update-home-dates-for-reviews', fromDate.format("YYYY-MM-DD"), toDate.format("YYYY-MM-DD"), type)
            }
        }
    }
})